import { FlagByLanguageType } from "@/app/locales/types";

import {
  thFlag,
  usFlag,
  spainFlag,
  germanyFlag,
  italyFlag,
  russiaFlag,
  chinaFlag,
  frenchFlag,
  aeFlag,
} from "@/assets/images/flags/utils";

export const flagByLanguage: FlagByLanguageType[] = [
  {
    flag: thFlag,
    language: "th",
    title: "Thai",
  },
  {
    flag: usFlag,
    language: "en",
    title: "English",
  }
];
